import * as d3 from 'd3';

export const parseDate = d3.utcParse('%Y-%m-%dT%H:%M:%SZ');
